import cls from './ReviewDone.module.scss'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const ReviewDone = () => {
  return (
    <p className={cls.ReviewDone}><span className={cls.IconCheck}><CheckCircleIcon color='success' /></span>{' '}отзыв оставлен</p>
  )
}
